// Meta (Facebook) Pixel helper.
// Loads the pixel base code once, fires PageView on init, and exposes a
// typed helper for AddToCart so we can call it wherever we redirect to Shopify.

const PIXEL_ID = '1745979086398479'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Injects the Meta Pixel base script (idempotent) and fires the initial
 * PageView. Safe to call multiple times — the load only happens once.
 */
export function initPixel(): void {
  if (typeof window === 'undefined') return
  if (initialized || window.fbq) {
    // Pixel already present — still make sure a PageView is recorded.
    if (window.fbq) window.fbq('track', 'PageView')
    return
  }
  initialized = true

  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      // No existing <script> tag in this document (e.g. sandboxed iframe) —
      // fall back to appending to <head>, or <body> if head is missing.
      ;(b.head || b.body || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

/** Fire a PageView event (used on load). */
export function trackPageView(): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'PageView')
}

/**
 * Fire an AddToCart event. Call right before redirecting the user to the
 * Shopify checkout so the conversion is attributed to the click.
 */
export function trackAddToCart(params?: {
  value?: number
  currency?: string
  contents?: unknown
}): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'AddToCart', {
    currency: params?.currency ?? 'USD',
    value: params?.value,
    contents: params?.contents,
  })
}
